<template>
  <li
    class="d-flex align-items-end align-items-center justify-content-center mx-2"
  >
    ...
  </li>
</template>
